// ==========================================
// COMPONENT: Skip to main
// OVERVIEW:  For better accessibility
// USAGE:     App
// ==========================================

import './skipToMain.css'

export default function SkipToMain() {
  return (
    <a className="skip-to-main" href="#main-content">
      Skip to main content
    </a>
  );
}
